import type { ViewForSiderFieldsFragment } from '@salescore/client-api'
import { FolderPathAndCreator } from '@salescore/client-common'
import { isNotNullish } from 'effect/Predicate'
import { useMemo } from 'react'

import { useSearchParentViewGroups } from '../../../../../recoil/view/selectors/viewsRelatedSelector'

interface Properties {
  view: Pick<ViewForSiderFieldsFragment, 'name' | 'viewGroupId' | 'createdBy'>
  showPath?: boolean
}

export const ViewListItem = (properties: Properties) => {
  const { view } = properties
  const searchParentViewGroups = useSearchParentViewGroups()

  const paths = useMemo(() => {
    if (isNotNullish(view.viewGroupId) && view.viewGroupId !== '') {
      return searchParentViewGroups(view.viewGroupId)
        .toReversed()
        .map((viewGroup) => viewGroup.name)
    }
  }, [view.viewGroupId, searchParentViewGroups])

  return (
    <div>
      <div className="whitespace-pre-wrap break-words pb-1">{view.name}</div>
      <FolderPathAndCreator path={paths} createdBy={view.createdBy?.name} />
    </div>
  )
}
